import { render, staticRenderFns } from "./sale_record.vue?vue&type=template&id=ceb29154&scoped=true&"
import script from "./sale_record.vue?vue&type=script&lang=ts&"
export * from "./sale_record.vue?vue&type=script&lang=ts&"
import style0 from "./sale_record.vue?vue&type=style&index=0&id=ceb29154&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceb29154",
  null
  
)

export default component.exports